import React from "react";

interface ClearableTextInputProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
}

const ClearableTextInput: React.FC<ClearableTextInputProps> = ({
  placeholder,
  value,
  onChange,
}) => {
  const handlePetNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    onChange(value);
  };

  const handleClearClick = () => {
    onChange("");
  };

  return (
    <div className="flex items-start justify-center">
      <div className="relative w-full max-w-sm">
        <input
          name="pet-name-input-textfield"
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={handlePetNameChange}
          className="w-full min-w-[250px] min-h-[52px] pl-3 pr-10 border !border-primary rounded-md focus:outline-none focus:ring-2 focus:ring-primary-hover"
        />
        <button
          type="button"
          className="absolute top-0 right-0 min-h-[52px] px-3 bg-primary hover:!gray-50 hover:!bg-primary-hover !border-primary !rounded-none text-gray-50 hover:!text-gray-50 !rounded-r focus:outline-none flex items-center justify-center"
          onClick={handleClearClick}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={4}
            stroke="currentColor"
            className="w-4 h-4"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ClearableTextInput;
